import { createFileRoute } from "@tanstack/react-router";
import { RunLogScreen } from "../screens/staff/RunLogScreen.tsx";

/**
 * `/sysadmin/runs/:accessId/:runId`: one run's log, redacted by the database. Opening it from the start is one line in
 * the company's security log; "show more events" reads on from where the page stopped and adds none.
 */
export const Route = createFileRoute("/_staff/sysadmin/runs/$accessId/$runId")({
  component: RunLogScreen,
});
